import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { useTranslation } from 'react-i18next';
import { _NkInput as NkInput } from '@nordkap/nordkap-ui';
import PropTypes from 'prop-types';
import { useStyles } from '../styles';
import { DefaultFieldsContainer } from '../default-fields/DefaultFieldsContainer';
import { useDebounce } from '../../../../hooks/useDebounce';

const CustomField = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [customFieldValue, setCustomFieldValue] = useState(
    props.customField.name
  );
  const debouncedValue = useDebounce(customFieldValue, 300);
  const defaultFieldsContainer = DefaultFieldsContainer.useContainer();

  const handleChange = event => {
    setCustomFieldValue(event.target.value);

    defaultFieldsContainer.setDirtyState(true);
  };

  useEffect(() => {
    props.changeField(props.customField.customFieldId, debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  return (
    <>
      <Grid item container xs={4}>
        <NkInput
          name={props.customField.name}
          variant="outlined"
          value={customFieldValue}
          onChange={handleChange}
          placeholder={t('customField.name')}
          required={customFieldValue === ''}
        />
      </Grid>
      <Grid item container xs={4}>
        <Button
          id="removeCustomField"
          variant="outlined"
          color="primary"
          title={t('fieldsAndTemplatesPage.removeCustomField')}
          onClick={() => props.removeField(props.customField.customFieldId)}
          className={classes.CustomFieldButton}
        >
          <DeleteIcon />
        </Button>
      </Grid>
      <Grid item container xs={3} />
    </>
  );
};

CustomField.propTypes = {
  customField: PropTypes.object,
  changeField: PropTypes.func,
  removeField: PropTypes.func,
};

export default CustomField;
